// extracted by mini-css-extract-plugin
export var active = "_3g-2";
export var errorDot = "_3g-3";
export var sideNavContainer = "_3g-0";
export var sideNavLink = "_3g-1";